import type { AuthPermissionUser } from '../../services/authPermissions';

const TRANSPORT_ROUTE_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS'];
const TRANSPORT_ROUTE_DELETION_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageTransportRoutes(user: AuthPermissionUser | null | undefined): boolean {
  return TRANSPORT_ROUTE_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteTransportRoute(user: AuthPermissionUser | null | undefined): boolean {
  return TRANSPORT_ROUTE_DELETION_ROLES.includes(user?.role || '');
}
